module.exports = __webpack_public_path__ + "static/media/home-ikea.20a422bf.png";